import React from 'react';

export var FormContext = React.createContext({
  isHorizontal: false
});


//////////////////
// WEBPACK FOOTER
// ./node_modules/@patternfly/react-core/dist/esm/components/Form/FormContext.js
// module id = 69
// module chunks = 0